import { ManageTab} from "./ManageTab";

export default ManageTab;
